"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const configs = {
    state: {
        secondary: "bg-gray-100 text-gray-900",
        success: "bg-success-50 text-success-500",
        error: "bg-error-50 text-error-500",
        warning: "bg-warning-50 text-warning-500",
        info: "bg-blue-50 text-blue-500",
        custom: "",
    },
    size: {
        xs: "text-xs h-5",
        sm: "text-xs h-8",
        md: "text-sm h-10",
        lg: "text-base h-12",
    },
};
exports.default = configs;
